module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kZ2n6"))).then(() => parcelRequire('1iHdE'));